// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LoOa","btnViewMore":"styles_btnViewMore__27i0E","disabledCard":"styles_disabledCard__Fh-Vx"};